module.exports = __webpack_public_path__ + "56c3bb61371908721ac6509800958953.svg";